module.exports = __webpack_public_path__ + "media/images/common/menu_accessory_ov-649d9ee0e003d297bdf179cd3729d282.gif";